/**
 * Die eine Stelle, die ein Access Token für unsere API holt (Muster aus Axis).
 * `acquireTokenSilent` nutzt den MSAL-Cache und erneuert im Hintergrund; nur wenn das
 * nicht reicht, führt `InteractionRequiredAuthError` zu einem echten Login-Redirect.
 */
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { anmeldeAnfrageFuerApi } from './msalConfig';
import { msalInstanz } from './msalInstanz';

export async function holeAccessToken(): Promise<string> {
  const instanz = msalInstanz();
  // Rückfall auf das einzige Konto im Cache, falls (noch) keins aktiv gesetzt ist
  const konto = instanz.getActiveAccount() ?? instanz.getAllAccounts()[0];
  if (!konto) throw new Error('Kein angemeldetes Konto.');
  const anfrage = anmeldeAnfrageFuerApi();
  try {
    return (await instanz.acquireTokenSilent({ ...anfrage, account: konto })).accessToken;
  } catch (fehler) {
    if (fehler instanceof InteractionRequiredAuthError) {
      // navigiert zum Login – dieser Aufruf kehrt nicht zurück
      await instanz.acquireTokenRedirect({ ...anfrage, account: konto });
    }
    throw fehler;
  }
}

export async function abmelden(): Promise<void> {
  await msalInstanz().logoutRedirect();
}
